import { Injectable, isDevMode, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import Clarity from '@microsoft/clarity';
const _ClarityProjectId = 'pjj0oott9l';

@Injectable({
  providedIn: 'root',
})
export class ClarityService {
  private platformId = inject(PLATFORM_ID);


  init() {
    // SSR-safe: Only initialize in browser environment
    if (isDevMode() || !isPlatformBrowser(this.platformId)) return;
    Clarity.init(_ClarityProjectId);
  }
}
